module.exports = __webpack_public_path__ + "static/bluecollartrader_small.d331233e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/bluecollartrader_small.png
// module id = 504
// module chunks = 79718873386587